// Module
var code = "<iframe data-bind=\"attr: { src: _src }, event: { load: LoadFinished.bind($data) }\" style=\"display:block;border:none;height:95vh;width:97vw\"></iframe>";
// Exports
export default code;